module.exports={"Clear search":"Ryd søgning"};